import Image from 'next/image';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import {
  cardServedEvent,
  clickCardEvent,
} from '../../../Utils/StoreHomePageUtils';
import {
  CarouselImageDiv,
  IVFCarouselCSS,
  IVFCarouselWrapper,
} from '../../IVF/IVFCarousel/styled';
import AnchorCoverTag from '../AnchorCoverTag';
import { fireEvent } from '../../../Utils/fireEvent';
import { getWebUserId } from '../../../Utils/helper';

export default function TopCarousel(props) {
  const {
    banner,
    type,
    noMobileCategory,
    catHideHeader,
    noSubcategory,
    isParentingPage,
    StoreHome,
    clothDiaperPage,
    milkBankTool,
    tuesdayPage,
    experimentType,
    happiness,
    innerCarousel,
    lactoMama,
    lactoMamaCategory,
    forceMobileViewAssetsDownload,
    isForNewCdPage,
    showSmallView,
    isForJoyfulPage,
  } = props;

  const carousel = useRef();
  const router = useRouter();
  const [clickEffect, setClickEffect] = useState(null);
  const getCarouselExperimentCondition = () => true;
  const [currentSlide, setCurrentSlide] = useState(1);
  const carousel_autoplay = getCarouselExperimentCondition() ? false : true;
  const carousel_arrows = getCarouselExperimentCondition() ? true : false;
  const carousel_interval = getCarouselExperimentCondition() ? 3000 : 5000;
   // Refs for impression tracking
   const itemRefs = useRef([]);
   const fired = useRef(new Set());
   const carouselContainerRef = useRef(null);
  const bannerClickHandler = (index, link, product) => {
    const sectionDetails = {
      heading: banner?.itemName,
      itemId: banner?._id,
    };
    clickCardEvent(product, sectionDetails, isParentingPage);
    router.push(product?.deeplinkValue + window.location.search);
  };
  useEffect(() => {
    cardServedEvent(banner, isParentingPage);
  }, []);
  const getDesktopImage = (product) => {
    return product?.desktopImage || product?.mobileWebImage || product?.image;
  };
  const getMobileImage = (product) => {
    return product?.mobileWebImage || product?.desktopImage || product?.image;
  };

// Helper function to fire impression event
const fireImpressionEvent = (idx) => {
  if (fired.current.has(idx)) return;
  
  fired.current.add(idx);
  const element = banner?.items?.[idx] || {};
  
  fireEvent({
    category: 'impression_card_in_store_home',
    card_name: element?.itemName || element?.nickname || element?.name || `carousel_card_${idx + 1}`,
    product_id: element?.productId || element?.product_id || element?._id || 'NA',
    user_id: getWebUserId() || 'NA',
   
    query_params:
      typeof window !== 'undefined'
        ? window.location.search || 'NA'
        : 'NA',
    screen_name: 'Store',
    datetime: new Date().toISOString(),
    section_name: banner?.itemName || banner?.heading || 'Top Carousel',
  });
};

 // Set up IntersectionObserver for horizontal scroll tracking
 useEffect(() => {
  if (!banner?.items?.length || !StoreHome) return;

  const setupObserver = () => {
    const validRefs = itemRefs.current.filter((el) => el !== null && el !== undefined);
    
    if (validRefs.length === 0) {
      requestAnimationFrame(setupObserver);
      return;
    }

    // Get carousel container - react-responsive-carousel renders slides in a specific structure
    const carouselElement = carouselContainerRef.current || 
      document.querySelector('.carousel-root') ||
      document.querySelector('[class*="carousel"]');
    
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const idx = Number(entry.target.dataset.index);
          
          if (isNaN(idx)) return;
          
          fireImpressionEvent(idx);
          io.unobserve(entry.target);
        });
      },
      {
        root: carouselElement || null,
        rootMargin: '0px',
        threshold: [0.5], // Fire when 50% visible
      }
    );

    validRefs.forEach((el) => {
      if (el) {
        io.observe(el);
      }
    });

    return () => io.disconnect();
  };
  const rafId = requestAnimationFrame(setupObserver);

  return () => {
    cancelAnimationFrame(rafId);
  };
}, [banner?.items, StoreHome]);


  return (
    <IVFCarouselWrapper
      noMobileCategory={noMobileCategory}
      clothDiaperPage={clothDiaperPage}
      lactoMama={lactoMama}
      lactoMamaCategory={lactoMamaCategory}
      fullWidth={true}
      StoreHome={StoreHome}
      isParentingPage={isParentingPage}
      isForJoyfulPage={isForJoyfulPage}
    >
      {banner?.sectionBgImage ? (
        <img className="headerImage" src={banner?.sectionBgImage} alt="" />
      ) : null}
      <IVFCarouselCSS
        milkBankTool={milkBankTool}
        clothDiaperPage={clothDiaperPage}
        StoreHome={StoreHome}
        showSmallView={showSmallView}
        happiness={happiness}
        color={'rgb(73,139,91)'}
        isForNewCdPage={isForNewCdPage}
        lactoMamaCategory={lactoMamaCategory}
      >
        <Carousel
          showIndicators={
            banner?.items?.length > 1 && !tuesdayPage ? true : false
          }
          showThumbs={false}
          emulateTouch
          preventMovementUntilSwipeScrollTolerance={innerCarousel}
          showArrows={clothDiaperPage ? carousel_arrows : false}
          showStatus={false}
          autoPlay={
            StoreHome ? StoreHome : clothDiaperPage ? carousel_autoplay : false
          }
          infiniteLoop={true}
          ref={carousel}
          interval={clothDiaperPage ? carousel_interval : 4000}
          onChange={(index) => {
            setCurrentSlide(index + 1);
          }}
          renderArrowNext={(onClick) => {
            return banner?.items?.length > 1 ? (
              <img
                src="https://images.myloapp.in/NestJsUploads/1723454730187-right-(1).webp"
                alt=""
                onClick={() => {
                  setClickEffect('right');
                  onClick();

                  setTimeout(() => {
                    setClickEffect(null);
                  }, 400);
                }}
                className={`customArrow ${
                  clickEffect === 'right' ? 'lowOpacity' : ''
                }`}
                // aria-label={"Next Slide"}
                // right={true}
              />
            ) : null;
          }}
          renderArrowPrev={(onClick) => {
            return banner?.items?.length > 1 ? (
              <img
                src="https://images.myloapp.in/NestJsUploads/1723454730186-Left-(1).webp"
                alt=""
                onClick={() => {
                  setClickEffect('left');
                  onClick();

                  setTimeout(() => {
                    setClickEffect(null);
                  }, 400);
                }}
                className={`customArrow leftArr ${
                  clickEffect === 'left' ? 'lowOpacity' : ''
                } ${currentSlide == 1 ? 'disabled' : ''}`}
                // aria-label={"Prev Slide"}
                // right={false}
              />
            ) : null;
          }}
        >
          {banner?.items?.map((element, index) => {
            return (
              <AnchorCoverTag
                url={element?.deeplinkValue}
                fragmentClass="anchorBlock"
                key={element?.image}
                cardEffect={'anchorBlock'}
                element={element}
                callbackFunction={bannerClickHandler}
              >
                <div
                  onClick={() =>
                    bannerClickHandler(element?.deeplinkValue, element)
                  }
                >
                  <CarouselImageDiv id={'carouselImageDiv' + (index + 1)}
                    ref={(el) => {
                      if (el) {
                        itemRefs.current[index] = el;
                      } else {
                        itemRefs.current[index] = null;
                      }
                    }}
                    data-index={index}
                  >
                    <Image
                      className="carousel-mobile"
                      src={getMobileImage(element)}
                      alt={element?.altText || ''}
                      quality={90}
                      priority={index == 0}
                      loading={index == 0 ? 'eager' : 'lazy'}
                      fill
                      sizes="70vw"
                    />
                    {/* Download Mobile view assets only */}
                    {forceMobileViewAssetsDownload ? null : (
                      <Image
                        className="carousel-desktop"
                        src={getDesktopImage(element)}
                        alt={element?.altText || ''}
                        quality={90}
                        priority={index == 0}
                        loading={index == 0 ? 'eager' : 'lazy'}
                        fill
                        sizes="100vw"
                      />
                    )}
                  </CarouselImageDiv>
                </div>
              </AnchorCoverTag>
            );
            // );
          })}
        </Carousel>
      </IVFCarouselCSS>
    </IVFCarouselWrapper>
  );
}
